import script from "./ClientFacilityFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientFacilityFilter.vue?vue&type=script&setup=true&lang=js"

import "./ClientFacilityFilter.vue?vue&type=style&index=0&id=2a90564c&lang=css"

const __exports__ = script;

export default __exports__